import { useContext } from 'react';

import WalletContext from '#src/contexts/wallet/index.tsx';
import { NoKeyError } from '#src/lib/errors/index.ts';

const useLoadWallet = () => {
  const { load } = useContext(WalletContext)!;
  return async (password: string) => {
    try {
      const wallet = await load({ password });
      return wallet;
    } catch (e) {
      if (e instanceof NoKeyError) return null;
      throw e;
    }
  };
};

export default useLoadWallet;
